import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import config from "@/config/config";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import { createMetaManager } from "vue-meta";

//引入less文件
import "./assets/less/index.less";

import animated from "animate.css/animate.min.css";

import func from "./store/funcs.js";

import VideoPlayer from "vue-video-player";
// import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(animated);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}
app.config.globalProperties.$func = func;
app.config.globalProperties.$config = config;
app.use(
	createMetaManager(false, {
		meta: { tag: "meta", nameless: true },
	})
);
app.use(VideoPlayer);
app.mount("#app");
